import { Link } from 'react-router-dom';
import { shell } from '../../shell/shellClasses';
import { formatInt, formatMoney, formatPct } from './format';
import type { SnapshotMetric } from './types';

export function MetricBlock({ metric }: { metric: SnapshotMetric }) {
  const valueText =
    metric.id === 'sales' || metric.id === 'aov'
      ? formatMoney(metric.value, metric.currencies[0])
      : formatInt(metric.value);

  const trendGlyph =
    metric.trend === 'up' ? '▲' : metric.trend === 'down' ? '▼' : metric.trend === 'flat' ? '●' : '·';
  const trendClass =
    metric.trend === 'up'
      ? 'text-[var(--shell-success)]'
      : metric.trend === 'down'
        ? 'text-[var(--shell-danger)]'
        : shell.muted;

  return (
    <Link
      to={metric.href}
      className={`group flex min-h-[104px] min-w-0 flex-col justify-between rounded-[var(--shell-radius-md)] border ${shell.border} ${shell.surfaceElevated} p-3 transition-colors duration-[var(--shell-motion-fast)] hover:bg-[var(--shell-hover)] ${shell.focusRing}`}
      aria-label={`${metric.label}: ${valueText}. Compare ${formatPct(metric.pctChange)}. Open Orders.`}
    >
      <div className="flex items-start justify-between gap-2">
        <p className={`text-xs font-medium ${shell.muted}`}>{metric.label}</p>
        {metric.availability !== 'available' && (
          <span className={`text-[10px] font-medium uppercase tracking-wide ${shell.subtle}`}>
            {metric.availability}
          </span>
        )}
      </div>
      <p className="mt-2 text-xl font-semibold tabular-nums tracking-tight text-[var(--shell-fg)]">
        {valueText}
      </p>
      <div className={`mt-2 flex flex-wrap items-center gap-2 text-xs ${shell.muted}`}>
        <span className={`inline-flex items-center gap-1 font-medium tabular-nums ${trendClass}`}>
          <span aria-hidden>{trendGlyph}</span>
          {formatPct(metric.pctChange)}
        </span>
        <span>vs prior day</span>
      </div>
      {metric.reason && <p className={`mt-1 text-[11px] leading-snug ${shell.subtle}`}>{metric.reason}</p>}
    </Link>
  );
}
